export default "__VITE_ASSET__ee763384__"